var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-swipe',{staticClass:"my-swipe",attrs:{"autoplay":3000,"indicator-color":"white"}},_vm._l((_vm.swipedata),function(item,index){return _c('van-swipe-item',{key:index},[_c('img',{attrs:{"src":item,"width":"100%"}})])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }